import React from "react"
import { IList } from "../models/Utils"

interface IProps<T> extends IList<T>{
    readonly onChange: (item: T) => void
}

interface IState<T>{
    readonly selected: T
    readonly showOptions: boolean
}

export abstract class Selector<T, K, P = unknown> extends React.Component<IProps<T> & P, IState<T>>{
    constructor(props: IProps<T> & P){
        super(props)

        this.state = {
            selected: null,
            showOptions: false
        }
    }

    protected checkDefault = (_: T, __: number) => false

    abstract getLabel: (item: T) => string

    abstract getKey: (item: T) => K

    componentDidMount = () => {
        window.addEventListener("click", this.hideOptions)

        this.setState({
            selected: this.props.list.find(this.checkDefault)
        })
    }

    componentWillUnmount = () => window.removeEventListener("click", this.hideOptions)

    hideOptions = () => this.setState({ showOptions: false })

    render = () => {
        const { selected, showOptions } = this.state,
        { list, onChange } = this.props

        return <div className="selector">
            <div className="selector-title" onClick={e => {
                e.stopPropagation()
                document.body.click()
                this.setState({ showOptions: true })
            }}>
                {this.getLabel(selected)}
            </div>
            {showOptions && <div className="selector-options" onClick={e => e.stopPropagation()}>
                {
                    list.map(s => <div className={"selector-opt " + (this.getKey(selected) === this.getKey(s) ? "selected" : "")} key={this.getKey(s) as string | number} onClick={() => this.setState({
                        selected: s,
                        showOptions: false
                    }, () => onChange(s))}>
                        {this.getLabel(s)}
                    </div>)
                }
            </div>}
        </div>
    }
}